<template>
  <div class="register-res">
    <img
      class="cup"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/drink_water_reminder_cup"
      alt=""
    />
    <img class="text" src="" alt="" />
    <div class="desc">
      您已成功绑定彩虹杯，请下载<span>betterWE App</span
      >，定制您的专属喝水方案，并使用配置喝水提醒服务，让我们一起好好喝水，悄悄变美～
    </div>
    <div class="space"></div>
    <div class="btn">
      <div @click="bindDownload">下载 betterWE星球APP</div>
      <div class="tip-circle circle-bottom">
        <div class="tip-content content-top">
          <div class="tip-text">
            彩虹杯与betterWE营养师团队定制的喝水方案需要搭配使用哦～
          </div>
          <img
            class="tip-image"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8e599953f9d7f084fefb1ea9c9769a3c.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    bindDownload() {
      location.href = 'https://member3.gymcity.com.cn/#/app-download'
    }
  }
}
</script>
<style lang="scss" scoped>
.register-res {
  width: 100%;
  height: 100vh;
  position: relative;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4a41cbc948c24ccbdbe2780cbe294712.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .cup {
    margin-top: 52px;
    width: 259px;
    height: 304px;
    object-fit: contain;
  }
  .text {
    margin-top: -6vh;
    width: 195px;
    height: 30px;
  }
  .space {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }
  .desc {
    width: 292px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.7);
    line-height: 24px;
  }
  .btn {
    position: relative;
    text-align: center;
    width: 283px;
    height: 44px;
    line-height: 44px;
    background: #1f2021;
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    text-shadow: 0px 6px 10px rgba(0, 0, 0, 0.12);
    margin-bottom: 12vh;
  }
  .tips {
    position: absolute;
    width: 241px;
    padding: 10px 9px;
    box-sizing: border-box;
    background: #6e44ff;
    border-radius: 10px;
    box-shadow: 0px 4px 6px 0px rgba(49, 6, 201, 0.3);
  }
  .tip-circle {
    position: absolute;
    left: 50%;
    top: -16px;
    transform: translate(-50%, -50%);
    z-index: 1;
    width: 0;
    height: 0;
    box-sizing: border-box;
  }
  .tip-content {
    position: absolute;
    width: 241px;
    background: #6e44ff;
    border-radius: 20px;
    padding: 10px 14px;
    padding-left: 51px;
    left: 50%;
    transform: translate(-50%, 0%);
    box-sizing: border-box;
    box-shadow: 0px 4px 6px 0px rgba(49, 6, 201, 0.3);
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 17px;
    text-align: center;
    .tip-text {
      display: inline-block;
      text-align: left;
    }
    .tip-image {
      width: 80px;
      height: 75px;
      position: absolute;
      left: -30px;
      bottom: 0px;
      object-fit: contain;
    }
  }
  .content-top {
    bottom: 8px;
  }
  .circle-bottom {
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 10px solid rgba(110, 68, 255, 1);
  }
}
</style>
